<div class="d-none" aria-hidden="true">
  <ng-template #uploadExternalContractModal let-modal>
    <div class="modal-header border-bottom-0 pb-2">
      <h3 class="modal-title d-flex align-items-center gap-2">
        <i class="bi bi-upload text-primary"></i>
        Upload External Contract
      </h3>
      <span (click)="modal.dismiss('Cross click')" role="button" class="ms-auto">
        <i class="bi bi-x-lg fs-20 text-muted"></i>
      </span>
    </div>
    <div class="modal-body pt-0">
      <div class="alert alert-warning d-flex align-items-start gap-2 mb-3">
        <i class="bi bi-exclamation-triangle fs-5"></i>
        <span>
          Uploading an external document moves this deal to Under Contract. You can replace it later if there is an
          issue, but the deal cannot return to a previous status.
        </span>
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">External Contract File <span class="text-danger">*</span></label>
        <input
          #externalContractFileInputRef
          type="file"
          class="d-none"
          accept=".pdf,.doc,.docx"
          (change)="onExternalContractFileChange($event)"
        />
        @if (externalContractFile(); as file) {
        <div class="border rounded-3 p-2 d-flex align-items-center gap-2">
          <i class="bi bi-file-earmark-text fs-5 text-primary"></i>
          <span class="text-truncate">{{ file.name }}</span>
          <span class="ms-auto small text-muted">{{ formatFileSize(file.size) }}</span>
          <button type="button" class="btn btn-link text-muted p-0 ms-1" (click)="removeExternalContractFile()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        } @else {
        <button
          type="button"
          class="btn btn-outline-secondary w-100 text-start"
          (click)="openExternalContractFilePicker()"
        >
          <i class="bi bi-upload me-2"></i>
          Choose file
        </button>
        } @if (showExternalContractValidation() && !externalContractFile()) {
        <div class="text-danger small mt-1">External contract file is required.</div>
        }
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">
          Date Signed @if (!document()) {<span class="text-danger">*</span>}
        </label>
        <p-datepicker
          [ngModel]="externalContractSignedDate()"
          (ngModelChange)="externalContractSignedDate.set($event); showExternalContractValidation.set(false)"
          [maxDate]="today"
          [autoZIndex]="true"
          [baseZIndex]="2000"
          [showIcon]="true"
          dateFormat="mm/dd/yy"
          appendTo="body"
          styleClass="w-100"
          inputStyleClass="w-100"
          placeholder="MM/DD/YYYY"
        />
        @if (document()) {
        <div class="text-muted small mt-1">Leave blank to keep the current signed date.</div>
        } @if (showExternalContractValidation() && !document() && !externalContractSignedDate()) {
        <div class="text-danger small mt-1">Date signed is required.</div>
        }
      </div>

      <div>
        <label class="form-label fw-semibold">Notes</label>
        <input type="text" class="form-control" [(ngModel)]="externalContractDescription" />
      </div>
      @if (!document()) {
      <div>
        <label class="form-label fw-semibold">Approval Date <span class="text-danger">*</span></label>
        <p-datepicker
          [ngModel]="externalContractApprovalDate()"
          (ngModelChange)="externalContractApprovalDate.set($event); showExternalContractValidation.set(false)"
          [autoZIndex]="true"
          [baseZIndex]="2000"
          [showIcon]="true"
          dateFormat="mm/dd/yy"
          appendTo="body"
          styleClass="w-100"
          inputStyleClass="w-100"
          placeholder="MM/DD/YYYY"
        />
        @if (showExternalContractValidation() && !externalContractApprovalDate()) {
        <div class="text-danger small mt-1">Approval date is required.</div>
        }
      </div>
      }
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="submitExternalContract(modal)"
        [disabled]="externalContractUploading()"
      >
        @if (externalContractUploading()) {
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        } {{document() ? 'Replace' : 'Upload'}} Contract
      </button>
    </div>
  </ng-template>
</div>
